import styled from 'styled-components';

export const ContainerImg = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 1rem;
  flex-direction: column;

  > div {
    display: flex;
    gap: 1rem;
  }
`;
